import React from "react";
import { COMPANY } from "../lib/contact";

const Datenschutz = () => (
  <div className="bg-[var(--na-bg)] pt-12 pb-24" data-testid="datenschutz-page">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-[11px] uppercase tracking-[0.3em] text-[var(--na-red)] font-semibold mb-3">DSGVO · Datenschutz</p>
      <h1 className="font-display text-4xl sm:text-5xl font-bold text-white tracking-tighter">Datenschutzerklärung</h1>

      <div className="mt-10 space-y-8 text-zinc-300 leading-relaxed text-sm lg:text-base">
        <Section title="Verantwortlicher">
          <p>{COMPANY.name} ({COMPANY.legal}), {COMPANY.address}, {COMPANY.zipCity}, {COMPANY.country}.<br />
            E-Mail: {COMPANY.email} · Telefon: {COMPANY.phone}</p>
        </Section>

        <Section title="Welche Daten verarbeiten wir?">
          <ul className="list-disc pl-5 space-y-1.5">
            <li>Daten aus dem Kontaktformular (Name, E-Mail, Telefon, Nachricht)</li>
            <li>Daten aus Fahrzeug-Ankaufsanfragen (Fahrzeugdaten, Beschreibung, ggf. Schadenshistorie, Kontaktdaten)</li>
            <li>Hochgeladene Fahrzeugfotos zur Bewertung</li>
            <li>Daten aus Finanzierungsanfragen (Fahrzeugpreis, Anzahlung, Wunschrate, Kontaktdaten)</li>
            <li>Daten aus Probefahrt-Anfragen</li>
            <li>Technische Daten (IP-Adresse, Browser, Zugriffszeit) – Analytics Platzhalter</li>
          </ul>
        </Section>

        <Section title="Zweck der Verarbeitung">
          <p>Die Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage, Vertragsanbahnung und gegebenenfalls Vertragsabwicklung verwendet. Eine darüberhinausgehende Verwendung erfolgt nur mit Ihrer ausdrücklichen Einwilligung.</p>
        </Section>

        <Section title="Weitergabe an Dritte">
          <p>Eine Weitergabe Ihrer Daten an Dritte erfolgt nur dann, wenn dies zur Vertragserfüllung notwendig ist (z.B. Finanzierungspartner-Bank bei einer ausdrücklich gewünschten Finanzierungsanfrage). Es erfolgt keine unnötige Datenweitergabe.</p>
        </Section>

        <Section title="WhatsApp-Kontakt">
          <p>Wenn Sie uns über WhatsApp kontaktieren, gelten zusätzlich die Datenschutzbestimmungen der WhatsApp Ireland Ltd. Wir verarbeiten die übermittelten Inhalte ausschließlich zur Beantwortung Ihrer Anfrage.</p>
        </Section>

        <Section title="Speicherdauer">
          <p>Personenbezogene Daten werden nur so lange gespeichert, wie es zur Erfüllung der Anfrage bzw. zur Erfüllung gesetzlicher Aufbewahrungspflichten erforderlich ist.</p>
        </Section>

        <Section title="Ihre Rechte">
          <ul className="list-disc pl-5 space-y-1.5">
            <li>Recht auf Auskunft</li>
            <li>Recht auf Berichtigung</li>
            <li>Recht auf Löschung</li>
            <li>Recht auf Einschränkung der Verarbeitung</li>
            <li>Recht auf Datenübertragbarkeit</li>
            <li>Widerspruchsrecht</li>
            <li>Beschwerderecht bei der Österreichischen Datenschutzbehörde</li>
          </ul>
          <p className="mt-3">Anfragen zur Löschung oder Auskunft bitte an {COMPANY.email}.</p>
        </Section>

        <Section title="Analytics / Cookies">
          <p>Wir setzen aktuell keine Tracking-Cookies ein. Sollten in Zukunft Analyse-Tools eingesetzt werden, wird diese Erklärung entsprechend angepasst und eine Einwilligung eingeholt.</p>
        </Section>

        <p className="text-xs text-zinc-500 pt-6 border-t border-white/5">
          Stand: {new Date().toLocaleDateString("de-AT")} · Weitere Angaben werden vor Veröffentlichung ergänzt.
        </p>
      </div>
    </div>
  </div>
);

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-display text-xl font-semibold text-white tracking-tight mb-3">{title}</h2>
    {children}
  </section>
);

export default Datenschutz;
